import React from 'react';
import { StarIcon } from 'lucide-react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
function Stars() {
  return <div className="flex gap-0.5 mb-2" data-id="element-352">
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-353" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-354" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-355" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-356" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-357" />
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-12 md:py-16 px-4" data-id="element-358">
      <div className="max-w-3xl mx-auto" data-id="element-359">
        <h2 className="text-3xl md:text-4xl font-black font-heading text-gray-900 text-center mb-10" data-id="element-360">
          💬 LO QUE DICEN LOS PADRES
        </h2>

        <div className="space-y-4" data-id="element-361">
          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-362">
            <Stars data-id="element-363" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-364">
              "Ya no termino el día agotada y culpable"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-365">
              — Ana C. | Mamá de niña de 7 años, Madrid
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-366">
            <Stars data-id="element-367" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-368">
              "Mi hijo sigue siendo intenso… pero ahora sé acompañarlo"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-369">
              — Patricia H. | Mamá de niño de 6 años, Guadalajara
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-370">
            <Stars data-id="element-371" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-372">
              "Por fin tengo un sistema, no improviso más"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-373">
              — Martín D. | Papá de niño de 9 años, Montevideo
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-374">
            <Stars data-id="element-375" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-376">
              "Pensé que era solo mi hijo, pero el problema era que yo no tenía
              herramientas. Ahora las tengo."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-377">
              — Carolina V. | Mamá de niña de 5 años, Bogotá
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-378">
            <Stars data-id="element-379" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-380">
              "Las rutinas visuales cambiaron todo. Mi hijo ahora sabe qué sigue
              y yo no tengo que repetir mil veces."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-381">
              — Fernanda L. | Mamá de niño de 7 años, CDMX
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-382">
            <Stars data-id="element-383" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-384">
              "Lo mejor es el protocolo de crisis. Cuando explota, ya sé
              exactamente qué hacer paso a paso."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-385">
              — Daniela R. | Mamá de niño de 9 años, Santiago
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-386">
            <Stars data-id="element-387" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-388">
              "Mi esposa y yo por fin estamos en la misma página. Antes cada uno
              reaccionaba distinto y era un caos."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-389">
              — Andrés M. | Papá de mellizos de 6 años, Buenos Aires
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-390">
            <Stars data-id="element-391" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-392">
              "Llevamos 3 semanas y las mañanas antes del colegio ya no son una
              guerra. Increíble la diferencia."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-393">
              — Valentina S. | Mamá de niña de 8 años, Lima
            </p>
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-394">
          <button onClick={scrollToPricing} className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl px-8 py-4 rounded-xl shadow-lg transition-colors duration-200 cursor-pointer font-heading" data-id="element-395">
            👉 QUIERO MI MEGAPACK AHORA
          </button>
        </div>
      </div>
    </section>;
}